import React, { FC, ReactNode } from 'react';
import { Box, Card } from '@wix/design-system';
import s from './CardLayout.scss';

export interface CardLayoutProps {
  children: ReactNode;
  className?: string;
  gap?: number;
  padding?: number;
}

export const CardLayout: FC<CardLayoutProps> = ({ children, className, gap = 1, padding = 5 }) => {
  return (
    <Card className={`${s.cardLayout} ${className || ''}`}>
      <Box direction="vertical" padding={padding} gap={gap}>
        {children}
      </Box>
    </Card>
  );
};
